import React, { useState } from "react";
import PageHeader from '../components/PageHeader';
import { submitContact } from "../services/contactService";

export default function Contact() {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Pages', link: '/pages' },
    { label: 'Contact Us', active: true },
  ];

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    subject: "",
    message: "",
  });

  // Contact form Start
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({
      ...formData,
      [id]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await submitContact(formData);
      setStatus("Your message has been sent successfully!");
      // Reset form
      setFormData({
        fullName: "",
        email: "",
        subject: "",
        message: "",
      });
    } catch (error) {
      console.error("Error submitting form", error);
      setStatus("There was an error sending your message.");
    }
  };
  // End

  return (
    <div>
      <>
        {/* Page Header Start */}
        <PageHeader title="Contact Us" breadcrumbs={breadcrumbs} />
        {/* Page Header End */}
        {/* Contact Start */}
        <div className="container-xxl py-5">
          <div className="container">
            <div
              className="text-center mx-auto mb-5 wow fadeInUp"
              data-wow-delay="0.1s"
              style={{ maxWidth: 600 }}
            >
              <h6 className="section-title bg-white text-center text-primary px-3">
                Contact Us
              </h6>
              <h1 className="display-6 mb-4">
                If You Have Any Query, Please Feel Free Contact Us
              </h1>
            </div>

            <div className="row g-0 justify-content-center">
              <div className="col-lg-8 wow fadeInUp" data-wow-delay="0.5s">
                {status && (
                  <div className="alert alert-success text-center fw-semibold" role="alert">
                    <i className="fa fa-check-circle me-2"></i>
                    {status}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="fullName"
                          placeholder="Your Name"
                          value={formData.fullName}
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="fullName">Your Name</label>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-floating">
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="Your Email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                        />
                        <label htmlFor="email">Your Email</label>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-floating">
                        <input
                          type="text"
                          className="form-control"
                          id="subject"
                          placeholder="Subject"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                        <label htmlFor="subject">Subject</label>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="form-floating">
                        <textarea
                          className="form-control"
                          placeholder="Leave a message here"
                          id="message"
                          style={{ height: 200 }}
                          value={formData.message}
                          onChange={handleChange}
                          required
                        ></textarea>
                        <label htmlFor="message">Message</label>
                      </div>
                    </div>

                    <div className="col-12 text-center">
                      <button
                        className="btn btn-primary rounded-pill py-3 px-5"
                        type="submit"
                      >
                        Send Message
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* Contact End */}
        {/* Google Map Start */}
        <div className="container-xxl pt-5 px-0 wow fadeIn" data-wow-delay="0.1s">
          <iframe
            className="w-100 mb-n2"
            style={{ height: 450 }}
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3001156.4288297426!2d-78.01371936852176!3d42.72876761954724!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4ccc4bf0f123a5a9%3A0xddcfc6c1de189567!2sNew%20York%2C%20USA!5e0!3m2!1sen!2sbd!4v1603794290143!5m2!1sen!2sbd"
            frameBorder={0}
            allowFullScreen=""
            aria-hidden="false"
            tabIndex={0}
          />
        </div>
        {/* Google Map End */}
      </>

    </div>
  )
}
